import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from 'reactstrap/lib/Button';
import Modal from 'reactstrap/lib/Modal';
import { SocialShareIcons } from 'site-modules/shared/components/social-share-icons/social-share-icons';
import { ShareLinkIcon } from 'site-modules/shared/components/social-media/share-link-icon/share-link-icon';

import './state-card.scss';

export class StateCard extends Component {
  state = {
    isShareLinkModalOpen: false,
  };

  componentDidMount() {
    if (this.props.closeOnClickOutside) {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }

  componentWillUnmount() {
    if (this.props.closeOnClickOutside) {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }

  onShareLinkModalOpen = () => this.setState({ isShareLinkModalOpen: true });

  onShareLinkModalClose = () => this.setState({ isShareLinkModalOpen: false });

  handleClickOutside = event => {
    const { isOpen } = this.props;
    const { isShareLinkModalOpen } = this.state;

    if (!this.ref.current) return;

    if (isOpen && !isShareLinkModalOpen && !this.ref.current.contains(event.target)) {
      this.props.onClose();
    }
  };

  ref = React.createRef();

  render() {
    const { cardTitle, children, pageTitle, pageUrl, isOpen, onClose, isModal, isAbsolutelyPositioned } = this.props;

    if (!isOpen) return null;

    const StateCardComponent = isModal ? Modal : 'div';

    const wrapperProps = isModal
      ? { toggle: onClose, isOpen, fade: false, className: 'state-card rounded bg-white centered' }
      : {
          className: classnames('state-card rounded bg-white my-md-1 mx-md-auto my-lg-0 mx-lg-0', {
            'p-absolute': isAbsolutelyPositioned,
          }),
          ref: this.ref,
        };

    return (
      <StateCardComponent {...wrapperProps}>
        <div className="bg-gray-lightest d-flex align-items-center justify-content-between px-1">
          <h3 className="heading-4 py-1 mb-0">{cardTitle}</h3>
          <Button className="close-button p-0" onClick={onClose} color="link">
            <i className="icon-cross2 text-gray-darker size-16" aria-hidden />
          </Button>
        </div>
        <div className="p-1">{children}</div>
        <div className="share-section text-gray-darker pb-1 pe-0_75 d-flex justify-content-end align-items-end">
          <span className="size-16">Share:</span>
          <SocialShareIcons className="size-12 text-gray-darker" title={pageTitle} url={pageUrl} />
          <ShareLinkIcon
            className="size-12 text-gray-darker px-0_25 py-0"
            url={pageUrl}
            onModalOpen={this.onShareLinkModalOpen}
            onModalClose={this.onShareLinkModalClose}
          />
        </div>
      </StateCardComponent>
    );
  }
}

StateCard.propTypes = {
  cardTitle: PropTypes.string,
  isOpen: PropTypes.bool,
  isModal: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  closeOnClickOutside: PropTypes.bool,
  isAbsolutelyPositioned: PropTypes.bool,
  pageTitle: PropTypes.string,
  pageUrl: PropTypes.string,
  children: PropTypes.node,
};

StateCard.defaultProps = {
  cardTitle: '',
  isOpen: true,
  isModal: false,
  closeOnClickOutside: false,
  isAbsolutelyPositioned: false,
  pageTitle: '',
  pageUrl: '',
  children: null,
};
